import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross and Blue Shield of Minnesota",
  shortName: "Blue Cross MN",
  slug: "blue-cross-mn-insurance",
  seoTitle:
    "Blue Cross and Blue Shield of Minnesota TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross and Blue Shield of Minnesota policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Blue Cross MN TMS coverage, Blue Cross Blue Shield Minnesota SPRAVATO authorization, Blue Cross MN mental health benefits Coral Springs FL, Blue Cross Minnesota depression treatment Florida",
};

export const BlueCrossMnInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default BlueCrossMnInsurance;
